module.exports = __webpack_public_path__ + "static/video-2-3bac3a4b0733b66f3d874d2755a1be8d.jpg";